const trim = require("mn-utils/trim");

module.exports = (auth, mainCallbackEnabled) => {
  if (!mainCallbackEnabled || !auth.enabled) {
    auth = {};
  }

  return {
    enabled: auth.enabled || false,
    type: auth.type || null,
    username: trim(auth.username || ''),
    password: trim(auth.password || ''),
    token: trim(auth.token || ''),
  };
}